import PersonIcon from "@mui/icons-material/Person";
import { Card, CardContent, Stack, Typography } from "@mui/material";

interface Props {
  shipment: PublicShipment | undefined;
}

export function PublicShipperInformationSection(props: Props) {
  const { shipment } = props;

  if (!shipment?.supplier) {
    return null;
  }

  const shipper = shipment.supplier;
  const shipperCompany = shipment.supplier_company;
  const shipperBranch = shipment.supplier.branch;

  return (
    <Card sx={{ flex: 1, minWidth: "300px", boxShadow: 1 }}>
      <CardContent>
        <Stack direction="column" spacing={2}>
          <Stack direction="column" spacing={1}>
            <Typography variant="h6">Shipper</Typography>
            <Typography variant="body1" fontWeight="bold">
              {shipperCompany.name}
              {shipperBranch && (
                <>
                  {" - "}
                  {shipperBranch.name}
                </>
              )}
            </Typography>
          </Stack>

          <Stack direction="row" alignItems="center" spacing={1}>
            <PersonIcon color="primary" fontSize="small" />
            <Typography variant="body1">
              {shipper.user.first_name} {shipper.user.last_name}
            </Typography>
          </Stack>
        </Stack>
      </CardContent>
    </Card>
  );
}
